"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFrameColor = exports.FRAME_COLORS = void 0;
var FRAME_COLORS;
(function (FRAME_COLORS) {
    FRAME_COLORS["BLACK"] = "black";
    FRAME_COLORS["WHITE"] = "white";
    FRAME_COLORS["WOOD"] = "wood";
    FRAME_COLORS["RED_ASH_WOOD"] = "red_ash_wood";
    FRAME_COLORS["NONE"] = "none";
})(FRAME_COLORS = exports.FRAME_COLORS || (exports.FRAME_COLORS = {}));
function getFrameColor(frame) {
    return frame.toLowerCase() === 'frameless'
        ? FRAME_COLORS.NONE
        : frame.toLowerCase();
}
exports.getFrameColor = getFrameColor;
//# sourceMappingURL=frames.js.map